// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-2d625655]::-webkit-outer-spin-button,\ninput[data-v-2d625655]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number][data-v-2d625655] {\n  -moz-appearance: textfield;\n}\n[data-v-2d625655] .composer-editor {\n  min-height: 125px;\n  max-height: 300px;\n}\n[data-v-2d625655] .articles-section {\n  max-height: 200px;\n}", ""]);
// Exports
module.exports = exports;
